import React, { useContext } from 'react';
import i18next from 'i18next';
import SubpageBlue from '../../SubpageBlue';
import Infobox from '../../../../AutostadtTabComponents/Tiles/Infobox';
import { FullWidthButton, Textlink } from '../../../../AutostadtTabComponents/Button';
import { Trans } from 'react-i18next';
import './styles.scss';
import { setOverlay } from '../../../../../utils/SspProvider/dispatchFunctions';
import { OverlayEnum } from '../../../../../enums';
import SspProviderContext from '../../../../../utils/SspProvider/context';
import VideoPlayer from '../../../../VideoPlayer';

export default function ProcedureOnSite() {
    const store = useContext(SspProviderContext);

    return (
        <SubpageBlue
            title={i18next.t('ProcedureOnSiteTitle')}
            className='procedure-on-site'
            headerChildren={
                <>
                    <p className='body large'>
                        <Trans
                            i18nKey='ProcedureOnSiteSubline'
                            components={{
                                strong: <strong />,
                                br: <br />,
                            }}
                        />
                    </p>
                    <svg className='car-bow'>
                        <use xlinkHref='#car-bow' />
                    </svg>
                </>
            }
        >
            <>
                <div className='video-list-container'>
                    <div className='video-item'>
                        <h3>{i18next.t('CheckIn')}</h3>
                        <VideoPlayer  link={'/AutostadtTab/durchatmen.webm'} filetype={'webm'} videoId={'durchatmen'} showAdditionalPlayIcon={true}/>
                        <p className='body large'>{i18next.t('CheckInParagraph')}</p>
                    </div>
                </div>
                <div className='white-background'>
                    <div className='light-blue'>
                        <h3>{i18next.t('ProcedureOnSiteLightBlueBoxTitle')}</h3>
                        <p className='body large'>{i18next.t('ProcedureOnSiteLightBlueBoxText')}</p>
                    </div>
                    <Infobox headline={i18next.t('Questions')}>
                        <div>
                            <p className='body large bold'>{i18next.t('ProcedureOnSiteSubHeader')}</p>
                            <p className='body large'>{i18next.t('ProcedureOnSiteParagraph')}</p>
                            <p className='body large bold'>{i18next.t('Contact')}</p>

                            <Textlink
                                type={'svg-left'}
                                color={'dark-blue'}
                                text={i18next.t('ProcedureOnSitePhoneNumber')}
                                svg='#as-phone'
                                onClick={() => {
                                    const numberWithoutSpaces = i18next
                                        .t('ProcedureOnSitePhoneNumber')
                                        .replace(/\s+/g, '');
                                    window.location.href = `tel:${numberWithoutSpaces}`;
                                }}
                            />

                            <Textlink
                                type={'svg-left'}
                                color={'dark-blue'}
                                text={i18next.t('ContactEmailAddress')}
                                svg='#as-email'
                                onClick={() => {
                                    const email = i18next.t('ContactEmailAddress');
                                    window.location.href = `mailto:${email}`;
                                }}
                            />
                            <FullWidthButton
                                type='primary'
                                color='blue'
                                text={i18next.t('ProcedureOnSiteButton')}
                                onClick={() => {
                                    setOverlay(store, {
                                        enum: OverlayEnum.ExternalContent,
                                        media: 'https://autostadt.survalyzer.eu/nrrgodwpvh?l=de',
                                    });
                                }}
                            />
                        </div>
                    </Infobox>
                </div>
            </>
        </SubpageBlue>
    );
}
